import React, { useState } from "react";
import Navbar from "./Navbar";

const impactData = {
  "Jobs & Opportunity": {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
      </svg>
    ),
    calculate: (amount) => {
      if (amount < 50) return { individual: `funds ${Math.round(amount * 1.2)} minutes of worker training`, collective: `R${amount} from 1,000 people equals R${(amount * 1000).toLocaleString()}, enough to employ one person for ${Math.round(amount * 1000 / 8000)} months` };
      if (amount < 200) return { individual: `funds ${Math.round(amount / 100)} full day${amount >= 100 ? "s" : ""} of a worker's wage`, collective: `R${amount} from 500 people equals R${(amount * 500).toLocaleString()}, enough to hire 3 workers for a month` };
      if (amount < 1000) return { individual: `funds one employment starter kit for a job seeker`, collective: `R${amount} from 200 people equals R${(amount * 200).toLocaleString()}, enough to launch a small community business` };
      return { individual: `funds ${Math.round(amount / 8000)} month${amount >= 16000 ? "s" : ""} of a worker's full salary`, collective: `R${amount} from 100 people equals R${(amount * 100).toLocaleString()}, enough to build and staff a community workshop` };
    }
  },
  "Infrastructure": {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 17l4-8 4 4 4-6 4 10"/><path d="M3 20h18"/>
      </svg>
    ),
    calculate: (amount) => {
      if (amount < 50) return { individual: `funds ${Math.round(amount * 0.5)}kg of cement for road repair`, collective: `R${amount} from 1,000 people equals R${(amount * 1000).toLocaleString()}, enough to repair a full street pothole` };
      if (amount < 200) return { individual: `funds ${Math.round(amount / 30)} square metres of road patching material`, collective: `R${amount} from 500 people equals R${(amount * 500).toLocaleString()}, enough to repair 500m of damaged road` };
      if (amount < 1000) return { individual: `funds enough gravel and material to fix 3 potholes`, collective: `R${amount} from 200 people equals R${(amount * 200).toLocaleString()}, enough to resurface an entire community road` };
      return { individual: `funds a full day of road crew labour and materials`, collective: `R${amount} from 100 people equals R${(amount * 100).toLocaleString()}, enough to build a small community bridge` };
    }
  },
  "Higher Education": {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
      </svg>
    ),
    calculate: (amount) => {
      if (amount < 50) return { individual: `funds ${Math.round(amount / 30)} textbook${amount >= 30 ? "s" : ""} for a student`, collective: `R${amount} from 1,000 people equals R${(amount * 1000).toLocaleString()}, enough to fully equip a student for a semester` };
      if (amount < 200) return { individual: `funds one month of student data and study materials`, collective: `R${amount} from 500 people equals R${(amount * 500).toLocaleString()}, enough to clear fees for 2 students` };
      if (amount < 1000) return { individual: `contributes toward clearing one student's outstanding balance`, collective: `R${amount} from 200 people equals R${(amount * 200).toLocaleString()}, enough to clear fees for 10 students` };
      return { individual: `covers one full semester of university fees for a student`, collective: `R${amount} from 100 people equals R${(amount * 100).toLocaleString()}, enough to send 10 students through a full year` };
    }
  },
  "Agriculture": {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a9 9 0 019 9c0 4-2.5 7.5-6 9M12 2a9 9 0 00-9 9c0 4 2.5 7.5 6 9M12 2v18"/>
      </svg>
    ),
    calculate: (amount) => {
      if (amount < 50) return { individual: `seeds half a vegetable garden that feeds a family`, collective: `R${amount} from 1,000 people equals R${(amount * 1000).toLocaleString()}, enough to plant a full community food garden` };
      if (amount < 200) return { individual: `funds one full vegetable garden for a family`, collective: `R${amount} from 500 people equals R${(amount * 500).toLocaleString()}, enough to start a community cooperative farm` };
      if (amount < 1000) return { individual: `covers irrigation materials for one farm plot`, collective: `R${amount} from 200 people equals R${(amount * 200).toLocaleString()}, enough to build a community greenhouse` };
      return { individual: `funds one month of a cooperative farm's operating costs`, collective: `R${amount} from 100 people equals R${(amount * 100).toLocaleString()}, enough to establish a fully operational community farm` };
    }
  },
  "Water & Sanitation": {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/>
      </svg>
    ),
    calculate: (amount) => {
      if (amount < 50) return { individual: `provides clean water to one family for a month`, collective: `R${amount} from 1,000 people equals R${(amount * 1000).toLocaleString()}, enough to install a community water tank` };
      if (amount < 200) return { individual: `funds water purification tablets for 10 families`, collective: `R${amount} from 500 people equals R${(amount * 500).toLocaleString()}, enough to drill a community borehole` };
      if (amount < 1000) return { individual: `covers piping materials for one household connection`, collective: `R${amount} from 200 people equals R${(amount * 200).toLocaleString()}, enough to connect 20 homes to clean water` };
      return { individual: `funds a full water storage and distribution system for a street`, collective: `R${amount} from 100 people equals R${(amount * 100).toLocaleString()}, enough to build a community water infrastructure network` };
    }
  },
  "Housing": {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10"/>
      </svg>
    ),
    calculate: (amount) => {
      if (amount < 50) return { individual: `buys ${Math.round(amount / 5)} bricks toward a community home`, collective: `R${amount} from 1,000 people equals R${(amount * 1000).toLocaleString()}, enough to build the foundation of one home` };
      if (amount < 200) return { individual: `covers roofing materials for one room`, collective: `R${amount} from 500 people equals R${(amount * 500).toLocaleString()}, enough to complete one community home` };
      if (amount < 1000) return { individual: `funds windows and doors for one household`, collective: `R${amount} from 200 people equals R${(amount * 200).toLocaleString()}, enough to build 2 complete homes` };
      return { individual: `covers labour costs for one complete room construction`, collective: `R${amount} from 100 people equals R${(amount * 100).toLocaleString()}, enough to build a full community housing unit` };
    }
  },
};

const presets = [10, 50, 100, 250, 500, 1000];

export default function ImpactCalculator() {
  const [category, setCategory] = useState("");
  const [amount, setAmount] = useState("");
  const [result, setResult] = useState(null);

  const calculate = () => {
    if (!category || !amount || isNaN(amount) || Number(amount) < 1) return;
    const data = impactData[category];
    const impact = data.calculate(Number(amount));
    setResult({ ...impact, icon: data.icon, category });
  };

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <style>{`
        .impact-wrap { max-width: 700px; margin: 0 auto; padding: 56px 24px 72px; }
        .impact-card { background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 32px; }
        .impact-cat-grid { display: flex; flex-wrap: wrap; gap: 8px; }
        .impact-presets { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
        .impact-preset-btn { border-radius: 8px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: var(--font-body); flex: 1; min-width: 60px; text-align: center; }
        .impact-result { margin-top: 20px; background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 32px; }
        @media (max-width: 480px) {
          .impact-wrap { padding: 32px 16px 48px; }
          .impact-card { padding: 20px; border-radius: 16px; }
          .impact-result { padding: 20px; border-radius: 16px; }
          .impact-cat-grid button { font-size: 12px; padding: 7px 12px; }
          .impact-presets { gap: 6px; }
          .impact-preset-btn { padding: 8px 10px; font-size: 12px; }
        }
      `}</style>

      <Navbar />

      <div className="impact-wrap">

        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", marginBottom: 20, fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
            Impact Calculator
          </div>
          <h1 style={{ fontSize: "clamp(26px, 4vw, 44px)", fontWeight: 900, color: "#1A1A2E", margin: "0 0 16px", letterSpacing: "-0.02em" }}>
            See What Your <span style={{ color: "#1B3A6B" }}>Contribution</span> Builds
          </h1>
          <p style={{ color: "#888", fontSize: 15, lineHeight: 1.7, margin: 0 }}>
            No amount is too small. Every rand forges something real.
          </p>
        </div>

        {/* CALCULATOR */}
        <div className="impact-card">

          {/* CATEGORY SELECTION */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 }}>
              Select a Category
            </div>
            <div className="impact-cat-grid">
              {Object.keys(impactData).map((cat) => (
                <button
                  key={cat}
                  onClick={() => { setCategory(cat); setResult(null); }}
                  style={{ background: category === cat ? "#1B3A6B" : "#F5F0E8", border: `1.5px solid ${category === cat ? "#1B3A6B" : "#EDE8DF"}`, borderRadius: 99, padding: "8px 16px", color: category === cat ? "#fff" : "#4A4A6A", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "var(--font-body)" }}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* AMOUNT INPUT */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 }}>
              Enter Your Amount (ZAR)
            </div>
            <div className="impact-presets">
              {presets.map((preset) => (
                <button
                  key={preset}
                  onClick={() => { setAmount(String(preset)); setResult(null); }}
                  className="impact-preset-btn"
                  style={{ background: amount === String(preset) ? "#1B3A6B" : "#F5F0E8", border: `1.5px solid ${amount === String(preset) ? "#1B3A6B" : "#EDE8DF"}`, color: amount === String(preset) ? "#fff" : "#4A4A6A" }}
                >
                  R{preset}
                </button>
              ))}
            </div>
            <input
              type="number"
              placeholder="Or type any amount..."
              value={amount}
              onChange={(e) => { setAmount(e.target.value); setResult(null); }}
              style={{ width: "100%", background: "#F5F0E8", border: "1.5px solid #EDE8DF", borderRadius: 8, padding: "12px 14px", color: "#1A1A2E", fontSize: 16, fontFamily: "var(--font-body)", outline: "none", boxSizing: "border-box" }}
            />
          </div>

          {/* CALCULATE BUTTON */}
          <button
            onClick={calculate}
            disabled={!category || !amount}
            style={{ width: "100%", background: category && amount ? "#1B3A6B" : "#EDE8DF", border: "none", borderRadius: 99, padding: "15px", color: category && amount ? "#fff" : "#888", fontWeight: 800, fontSize: 15, cursor: category && amount ? "pointer" : "not-allowed", fontFamily: "var(--font-body)" }}
          >
            Calculate My Impact
          </button>
        </div>

        {/* RESULT */}
        {result && (
          <div className="impact-result">
            <div style={{ textAlign: "center", marginBottom: 28 }}>
              <div style={{ width: 56, height: 56, background: "#F5F0E8", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
                {result.icon}
              </div>
              <div style={{ fontSize: 11, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 }}>Your Contribution</div>
              <div style={{ fontSize: 44, fontWeight: 900, color: "#1B3A6B" }}>R{Number(amount).toLocaleString()}</div>
            </div>

            <div style={{ background: "#F5F0E8", border: "1px solid #EDE8DF", borderRadius: 12, padding: 18, marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: "#888", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 }}>Your Individual Impact</div>
              <div style={{ fontSize: 14, color: "#1A1A2E", lineHeight: 1.65 }}>
                Your <strong style={{ color: "#1B3A6B" }}>R{Number(amount).toLocaleString()}</strong> {result.individual}.
              </div>
            </div>

            <div style={{ background: "rgba(27,58,107,0.05)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 12, padding: 18, marginBottom: 20 }}>
              <div style={{ fontSize: 11, color: "#1B3A6B", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 }}>Collective Power</div>
              <div style={{ fontSize: 14, color: "#4A4A6A", lineHeight: 1.7 }}>{result.collective}.</div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, textAlign: "center", padding: "14px 18px", background: "rgba(46,125,50,0.06)", border: "1px solid rgba(46,125,50,0.15)", borderRadius: 12, marginBottom: 20, fontSize: 13, color: "#2E7D32", fontWeight: 600 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
              </svg>
              Every rand forges something real. Together we build South Africa.
            </div>

            <button
              onClick={() => window.location.href = "/projects"}
              style={{ width: "100%", background: "#C9A84C", border: "none", borderRadius: 99, padding: "14px", color: "#fff", fontWeight: 800, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}
            >
              Contribute Now
            </button>
          </div>
        )}

      </div>
    </div>
  );
}